import { withInstall } from '@ll-plus/utils'

import UploadImage from './src/upload-image.vue'

export const LlUploadImage = withInstall(UploadImage)
export default LlUploadImage
export * from './src/upload-image'

declare module 'vue' {
  export interface GlobalComponents {
    LlUploadImage: typeof LlUploadImage
  }
}
